module.exports = __webpack_public_path__ + "img/GABA.d0289dc0.png";